import  makeStyles  from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles(theme => ({
   showAlert : {
    display : "block"
   },
   hideAlert : {
    display: "none"
   }
  }));